import { CARTOPOUSSE_BASE_URL } from '../utils/ApiUrls';

class RiskManagerStatsService {

  // Get all dashboard statistics (4 cards data)
  async getRiskManagerDashboardStats(accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/riskmanager/dashboard-stats/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to fetch dashboard statistics',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get recent history records for admin dashboard
  async getRiskManagerRecentHistories(accessToken) {
    try {
      const response = await fetch(`${CARTOPOUSSE_BASE_URL}/riskmanager/recent-histories/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Failed to fetch recent histories',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


  // Get recent history records for admin dashboard
async getRecentHistories(accessToken) {
  try {
    const response = await fetch(`${CARTOPOUSSE_BASE_URL}/riskmanager/recent-histories/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: data.error || data.detail || 'Failed to fetch recent histories',
        errorData: data,
      };
    }

    return {
      success: true,
      status: response.status,
      data,
    };
  } catch (error) {
    return {
      success: false,
      status: 0,
      error: error.message || 'Network error occurred',
      errorData: null,
    };
  }
}


}

// Export singleton instance
const riskManagerStatsService = new RiskManagerStatsService();
export default riskManagerStatsService;